import {demoKitReady} from './state.js';

// Quest identity follows meaningful tasks, never item counts or localized copy.
export function questStep(state,{insideHouse=false}={}){
 let id;
 switch(state.stage){
  case 'drive':case 'turn':case 'park':id='arrival';break;
  case 'van-door':case 'exit':id='exit-van';break;
  case 'recall':case 'brief':id='brief';break;
  case 'follow':id=insideHouse?'join':state.houseDoorOpen?'enter':'open-door';break;
  case 'toolbox':id='open-case';break;
  case 'collect':id=demoKitReady(state)?'check':'prepare';break;
  case 'ready':case 'walk-to-board':id='walk-to-board';break;
  case 'demo':id='watch';break;
  case 'practice':id='fit-breaker';break;
  case 'fasten':id=state.held==='driver'?'fasten':'take-driver';break;
  case 'debrief':id='debrief';break;
  case 'turn-on-light':id='turn-on-light';break;
  default:return null;
 }
 return {id,titleKey:`quest.step.${id}`};
}

// An independent UI timer: no simulation ticks or WebGL animation loop.
export function createQuestNotice({now=()=>performance.now(),delay=setTimeout,cancel=clearTimeout,onChange=()=>{},duration=2800}={}){
 const seen=new Set();let current=null,lastId=null,remaining=0,paused=true,last=now(),timer=null;
 function stop(){if(timer!==null){cancel(timer);timer=null;}}
 function settle(){const time=now();if(current&&!paused)remaining=Math.max(0,remaining-Math.max(0,time-last));last=time;}
 function read(){return {quest:current?{...current}:null,visible:!!current&&!paused,paused,remaining:current?Math.max(0,remaining-(!paused?Math.max(0,now()-last):0)):0,seen:[...seen]};}
 function emit(kind){onChange({kind,...read()});}
 function schedule(){if(current&&!paused)timer=delay(()=>{timer=null;current=null;remaining=0;emit('hide');},remaining);}
 return {
  update(step,{enabled=true,paused:pause=false}={}){
   settle();stop();let kind=null;const wasPaused=paused;
   if(!enabled||!step||typeof step.id!=='string'||!step.id){const had=!!current;current=null;lastId=null;remaining=0;paused=true;if(had)emit('hide');return;}
   const next={id:step.id,title:String(step.title??''),label:String(step.label??'')};
   if(next.id!==lastId){
    lastId=next.id;const had=!!current;current=null;remaining=0;
    if(!seen.has(next.id)){seen.add(next.id);current=next;remaining=duration;kind='start';}else if(had)kind='hide';
   }else if(current&&(next.title!==current.title||next.label!==current.label)){current=next;kind='update';}
   paused=Boolean(pause);
   if(current&&wasPaused!==paused&&!kind)kind=paused?'pause':'resume';
   if(kind)emit(kind);schedule();
  },
  read,
  reset(){stop();seen.clear();current=null;lastId=null;remaining=0;paused=true;last=now();emit('hide');},
  dispose(){stop();current=null;remaining=0;paused=true;}
 };
}
